var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import cxs from 'cxs/component';
import { MessageType } from '../modules/UI/Model';
import Theme from 'Theme';
let UIMessage = class UIMessage extends Component {
    render() {
        const { noTop } = this.props;
        const { message } = this.props.store.UI;
        if (!message)
            return null;
        const { type, text } = message;
        let colors;
        switch (type) {
            case MessageType.Ok:
                colors = Theme.color.backgreen;
                break;
            case MessageType.Warning:
                colors = Theme.color.warningBackground;
                break;
            case MessageType.Error:
                colors = Theme.color.errorBackground;
                break;
            default:
        }
        if (!(noTop || !message.noTop)) {
            return null;
        }
        return (React.createElement(Message, { noTop: noTop, type: type, style: {
                zIndex: 20,
            } }, text));
    }
};
UIMessage = __decorate([
    inject('store'),
    observer
], UIMessage);
export default UIMessage;
const Message = cxs('div')(({ type, noTop }) => ({
    position: noTop ? 'inherit' : 'absolute',
    top: noTop ? 'inherit' : 0,
    left: noTop ? 'inherit' : 0,
    right: noTop ? 'inherit' : 0,
    padding: Theme.size.space[2],
    textAlign: 'center',
    textTransform: 'none',
    whiteSpace: 'pre',
    color: type === MessageType.Error
        ? Theme.color.errorText
        : type === MessageType.Warning
            ? Theme.color.warningText
            : type === MessageType.Ok
                ? 'green'
                : 'black',
    backgroundColor: type === MessageType.Error
        ? Theme.color.errorBackground
        : type === MessageType.Warning
            ? Theme.color.warningBackground
            : type === MessageType.Ok
                ? Theme.color.backgreen
                : 'black',
    zIndex: 20,
    ':first-letter': {
        textTransform: 'uppercase',
    },
}));
Message.propTypes = {
    type: PropTypes.string,
};



//////////////////
// WEBPACK FOOTER
// ./src/components/UIMessage.tsx
// module id = 554
// module chunks = 0